import { render } from "./PortfolioBackground.vue?vue&type=template&id=672ad8b0&scoped=true"
import script from "./PortfolioBackground.vue?vue&type=script&lang=ts"
export * from "./PortfolioBackground.vue?vue&type=script&lang=ts"

import "./PortfolioBackground.vue?vue&type=style&index=0&id=672ad8b0&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-672ad8b0"

export default script